import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const StyledIconsContainer = styled.div`
    color: ${Colors.primary};
    display: flex;
    gap: ${SPACING.SMALL_2};
    flex-direction: row-reverse;
`;
